import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import * as languages from 'date-fns/locale';
import format from 'date-fns/format';

import { selectGiftCardsDiscountData } from '@selectors/giftCards';

import { DAY_MONTHNAME, DAY_MONTHNAME_YEAR } from '@common/constants/dates';
import { isValidDiscount } from '../GiftCardsPurchase.helpers';

import { Message } from './DiscountMessage.styled';

const DiscountMessage = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const discount = useSelector(selectGiftCardsDiscountData);

  if (!isValidDiscount(discount)) {
    return null;
  }

  const discountEndDate = new Date(discount.end);

  return (
    <Message isBasketVersion>
      {t(
        'giftCards.order.info.discountPeriod',
        'Bis zum {{date_end}} sind unsere Geschenkkarten für Dich um {{percentage}}% reduziert.',
        {
          date_end: format(
            discountEndDate,
            discountEndDate.getFullYear() !== new Date().getFullYear()
              ? DAY_MONTHNAME_YEAR
              : DAY_MONTHNAME,
            {
              locale: languages[language],
            },
          ),
          percentage: discount.discountPercentage,
        },
      )}
    </Message>
  );
};

export default DiscountMessage;
